export const DRAG_IDLE = "drag-idle";
export const DRAG_HOVERED = "drag-hovered";
export const UPLOAD_INPROGRESS = "in-progress";
export const UPLOAD_IDLE = "upload-idle";
export const UPLOAD_UPLOADING = "upload-uploading";
export const UPLOAD_BAD_EXTENSION = "upload-bad-extension";
export const validExtensions = ["csv", "xls", "xlsx", "pdf", "doc"];
